import { DOCUMENT_COMPLETION_ERROR, DOCUMENT_COMPLETION_FINISHED } from '@app/config';
import { UploadStatus } from '@app/constants/constants';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getAgencyIntegrations } from '../../selectors/agency';
import { getDocumentList } from '../../selectors/dashboard/documentList';

type DocumentListType = {
    // CHORE: complete this type
    [docType: string]: {
        [status: string]: Array<{
            id: string;
            completion?: {
                status: string;
            };
        }>;
    };
};

type AgencyIntegrationsType = {
    // CHORE: complete this type
    reapitConsole?: {
        shouldPushFinishedDocuments: boolean;
    };
};

type CurrentDocumentType = {
    // CHORE: complete this type
    docType: string;
    status: string;
    id: string;
    completion?: {
        status: typeof DOCUMENT_COMPLETION_FINISHED | typeof DOCUMENT_COMPLETION_ERROR | string;
    };
    integration: {
        uploadStatus: UploadStatus;
    };
};

const useIntegrationButtonLoadingStatus = (currentDocument?: CurrentDocumentType) => {
    const agencyIntegrations = useSelector<unknown, AgencyIntegrationsType>(getAgencyIntegrations);
    const documentList = useSelector<unknown, DocumentListType>(getDocumentList);
    const onFirstUpload = useRef(false);

    const shouldPushFinishedDocuments = agencyIntegrations?.reapitConsole?.shouldPushFinishedDocuments;
    const status = documentList?.[currentDocument?.docType ?? '']?.[currentDocument?.status ?? '']?.find(
        doc => doc?.id === currentDocument?.id
    )?.completion?.status;

    useEffect(() => {
        if (status !== DOCUMENT_COMPLETION_FINISHED && status !== DOCUMENT_COMPLETION_ERROR && status !== undefined) {
            onFirstUpload.current = true;
        }
    }, [status]);

    const shouldShowUploadingStatus = () => {
        const isDocumentStillProcessing =
            shouldPushFinishedDocuments &&
            status !== DOCUMENT_COMPLETION_ERROR &&
            status !== DOCUMENT_COMPLETION_FINISHED;

        const isFirstTimeDefaultUpload =
            onFirstUpload.current && currentDocument?.integration?.uploadStatus === UploadStatus.DEFAULT;

        return isDocumentStillProcessing || isFirstTimeDefaultUpload;
    };

    return { shouldShowUploadingStatus: shouldShowUploadingStatus() };
};

export default useIntegrationButtonLoadingStatus;
